import {Model} from 'vue-mc';


/**
 * Reset Password model
 */
export default class RecoverPasswordModel extends Model {

    // Default attributes that define the "empty" state.
    defaults() {
        return {
            email: '',
            errorMessage: '',
            successMessage: '',
        }
    }

    // Attribute mutations.
    mutations() {
        return {
            email: String,
            successMessage: String,
            errorMessage: String
        }
    }
    // Attribute validation


    // Route configuration
    routes() {
        return {
            save: "contacts/password/send_link"
        }
    }
}


// WEBPACK FOOTER //
// ./src/models/recoverPasswordModel.js